import http from "../services/http";

// Get all chat rooms
export const apiGetChatRooms = async () => {
  try {
    const response = await http.get("/api/chat/rooms");
    return response;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// Get chat room details
export const apiGetRoomDetails = async (roomId) => {
  try {
    const response = await http.get("/api/chat/room-details", {
      params: { roomId },
    });
    return response;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// Get chat history
export const apiGetChatHistory = async (
  roomId = null,
  patientId,
  page = 1,
  limit = 50
) => {
  try {
    const response = await http.get("/api/chat/history", {
      params: { roomId, page, limit, chat_type: 1, patient_id: patientId },
    });
    return response;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// Set doctor as active
export const apiSetActiveDoctor = async () => {
  try {
    const response = await http.post("/api/chat/admin/set-active-doctor");
    return response;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// Set doctor as passive
export const apiSetPassiveDoctor = async () => {
  try {
    const response = await http.post("/api/chat/admin/set-passive-doctor");
    return response;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// Upload chat file
export const apiUploadChatFile = (formData) => {
  return http.post(
    "/api/chat/upload",
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
        Accept: "application/json",
      },
    }
  );
};


// Update chat room
export const apiUpdateChatRoom = async (roomId, data) => {
  try {
    const response = await http.patch("/api/chat/room-update", {
      roomId,
      ...data,
    });
    return response;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};
